import Group from "../../assets/images/photo-group.png";

import Button from "../../components/ui/button";

const JoinFooter = () => {
  return (
    <div>
      <div className="">
        <div className="container mx-auto p-2 pt-12 md:pt-16  md:p-10">
          <div className="flex flex-col items-center bg-fxBg bg-center bg-cover bg-no-repeat pt-10 gap-5">
            <h1 className="head text-4xl font-bold text-center">
              Join thousands of people on
              <br className="hidden md:block" /> the{" "}
              <span className="text-primary">borderless</span> culture
            </h1>
            <Button
              backgroundColor="#231F20"
              label="Get Started"
              loading={false}
              onClick={() => {}}
              type="contained"
              color="white"
              rounded
              long
            />
            <img src={Group} alt="" />
          </div>
        </div>
      </div>
      {/*  */}
      {/* <div className="">
        <div className="container mx-auto pb-10 p-3">
          <div className="flex flex-col md:flex-row gap-5 items-center justify-evenly">
            <img src={Flutterwave} alt="" />
            <img src={Airtel} alt="" />
            <img src={Mtn} alt="" />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default JoinFooter;
